module.exports = __webpack_public_path__ + "img/FSCL.978913f3.png";